<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content>
  <p class="mb-4">{{ data.text | translate }}</p>

  <!-- Loading state -->
  @if (loading) {
    <div class="loading-state">
      <mat-spinner diameter="40" class="ai-spinner-dialog" />
      <span class="loading-text">{{ 'PRODUCTION_TEXTS.AI_LOADING' | translate }}</span>
    </div>
  }

  @if (!loading) {
    <!-- Tabs -->
    <div class="tabs">
      <button
        class="tab"
        [class.active]="activeTab === 'server'"
        [disabled]="!hasServerFile"
        (click)="activeTab = 'server'"
        >
        <mat-icon>folder</mat-icon>
        <span>{{ 'PRODUCTION_TEXTS.AI_TAB_SERVER' | translate }}</span>
      </button>
      <button
        class="tab"
        [class.active]="activeTab === 'upload'"
        (click)="activeTab = 'upload'"
        >
        <mat-icon>cloud_upload</mat-icon>
        <span>{{ 'PRODUCTION_TEXTS.AI_TAB_UPLOAD' | translate }}</span>
      </button>
    </div>
    <!-- Tab: Server file -->
    @if (activeTab === 'server') {
      <div class="tab-content">
        <div class="server-file">
          <mat-icon class="text-tw-primary server-file-icon">picture_as_pdf</mat-icon>
          <span class="file-name">{{ data.fileName }}</span>
        </div>
      </div>
    }
    <!-- Tab: Upload file -->
    @if (activeTab === 'upload') {
      <div class="tab-content">
        <!-- Drop zone -->
        @if (!file) {
          <div
            class="drop-zone"
            [class.drag-over]="dragOver"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event)"
            (click)="fileInput.click()"
            >
            <mat-icon class="drop-icon">cloud_upload</mat-icon>
            <span class="drop-text">{{ 'PRODUCTION_TEXTS.AI_DROP_TEXT' | translate }}</span>
            <span class="drop-hint">PDF — 100 Mo max</span>
            <input #fileInput type="file" accept="application/pdf" hidden (change)="onFileSelect($event)">
          </div>
        }
        <!-- File selected -->
        @if (file) {
          <div class="file-preview">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <mat-icon class="text-tw-primary">picture_as_pdf</mat-icon>
                <span class="file-name">{{ file.name }}</span>
              </div>
              <button mat-icon-button type="button" (click)="removeFile()">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            @if (filePreviewUrl) {
              <iframe [src]="filePreviewUrl" class="pdf-preview"></iframe>
            }
          </div>
        }
      </div>
    }
    <!-- Error -->
    @if (error) {
      <p class="text-red-500 mt-2">{{ error | translate }}</p>
    }
    <!-- Disclaimer -->
    <p class="text-xs text-gray-600 mt-4 italic">{{ 'PRODUCTION_TEXTS.AI_DISCLAIMER' | translate }}</p>
  }
</mat-dialog-content>

@if (!loading) {
  <mat-dialog-actions class="w-full flex justify-between">
    <button mat-flat-button mat-dialog-close class="bg-tw-lightgrey flex-grow">
      {{ 'CANCEL' | translate }}
    </button>
    <button mat-flat-button [disabled]="!canSubmit" (click)="submit()" class="bg-tw-primary text-tw-text-light flex-grow">
      {{ 'PRODUCTION_TEXTS.AI_SUBMIT' | translate }}
    </button>
  </mat-dialog-actions>
}
